export const BondTypes = {
  bond_type: "bond_type",
  share_type: "share_type",
  eurobond_type: "eurobond_type",
  corporate_type: "corporate_type",
  all_type: "all_type",
};
